import { TemplateGallery } from '../components/Templates/TemplateGallery';

export function Templates() {
  return <TemplateGallery />;
}
